import api from './api';

export const contentService = {
  // Content cards
  cards: {
    getAll: async (params = {}) => {
      const response = await api.get('/content/cards', { params });
      return response.data;
    },
    create: async (cardData) => {
      const response = await api.post('/content/cards', cardData);
      return response.data;
    },
    update: async (id, cardData) => {
      const response = await api.put(`/content/cards/${id}`, cardData);
      return response.data;
    },
    delete: async (id) => {
      const response = await api.delete(`/content/cards/${id}`);
      return response.data;
    }
  },

  // Blog posts
  blog: {
    getAll: async (params = {}) => {
      const response = await api.get('/content/blog', { params });
      return response.data;
    },
    create: async (postData) => {
      const response = await api.post('/content/blog', postData);
      return response.data;
    },
    update: async (id, postData) => {
      const response = await api.put(`/content/blog/${id}`, postData);
      return response.data;
    },
    delete: async (id) => {
      const response = await api.delete(`/content/blog/${id}`);
      return response.data;
    }
  },

  // Lead requests
  leads: {
    getAll: async () => {
      const response = await api.get('/content/leads');
      return response.data;
    },
    updateStatus: async (id, status) => {
      const response = await api.put(`/content/leads/${id}/status`, { status });
      return response.data;
    },
    // Public endpoint - no auth required
    submitRequest: async (requestData) => {
      const response = await axios.post(`${API_BASE_URL}/content/leads/submit`, requestData);
      return response.data;
    }
  }
};
